import { useNavigateBack } from '@iheartjane/menu';
import { useEffect } from 'react';
import { useLocation } from 'react-router';

import { Modal, QRCodeCallout } from '@jane/kiosk/components';
import { useKioskAeropayUser, useKioskUser } from '@jane/kiosk/data-access';
import type { RootLoaderType } from '@jane/kiosk/data-access';
import {
  useTypedRouteLoaderData,
  useKioskBankLinkQrCode,
} from '@jane/kiosk/hooks';

import qrPng from '../assets/qr-logo.png';

export const LinkBank = () => {
  const { pathname } = useLocation();
  const { storeId } = useTypedRouteLoaderData<RootLoaderType>('root');
  const goBack = useNavigateBack(`stores/${storeId}/menu`);

  const { data: kioskUser } = useKioskUser();
  const { data: aeropayData } = useKioskAeropayUser(
    {
      janeUserId: kioskUser?.id,
    },
    {
      // refetch for aeropay data to check for linked bank accounts
      refetchInterval: 5000,
    }
  );

  const { error: qrCodeError, url: mobileLinkBankUrl } = useKioskBankLinkQrCode(
    {
      source: pathname.includes('checkout') ? 'Checkout' : 'Bag',
      storeId,
    }
  );

  // watch for linked bank accounts to navigate back
  useEffect(() => {
    if ((aeropayData?.bank_accounts?.length || 0) > 0) {
      goBack();
    }
  }, [aeropayData?.bank_accounts]);

  return (
    <Modal
      appId="root"
      contentLabel="Link Bank"
      onRequestClose={() => goBack()}
      open
      overlayClose
      variant="dialogue"
    >
      <Modal.Content padding={false}>
        <QRCodeCallout
          type="link-bank"
          buttonLabel="Go back"
          onClick={() => goBack()}
          qrCode={qrPng}
          url={mobileLinkBankUrl}
          error={qrCodeError}
        />
      </Modal.Content>
    </Modal>
  );
};
